import { defaultOptions, API_URL } from "./fetchOptions";
import { V1Res } from "./interfaces";
import * as V1Types from "./types/devices";

export const getAllDevices = (
  args: V1Types.AllDevicesRequestProps
): Promise<V1Res<V1Types.AllDevicesRequest>> => {
  return fetch(
    `${API_URL}/v1/device?locationOn=${args.withLocation}`,
    defaultOptions()
  ).then((res) => res.json());
};

export const getFromToDeviceReadings = (
  args: V1Types.FromToReadingsProps
): Promise<V1Res<V1Types.FromToReadingsResp>> => {
  return fetch(
    `${API_URL}/v1/device/${args.device_id}/${args.sensorType}?from=${args.from}&to=${args.to}&granularity=${args.granularity}`,
    defaultOptions()
  ).then((res) => res.json());
};
